module.exports = __webpack_public_path__ + "img/cash_white.7abf6dc9.svg";